/**
 * getUrlParameter is an object that can be used by all the app,
 * it returns a parameter value of the current url
 *
 * example :
 *
 * const data = "duree";
 * getUrlParameter(data);
 *
 */

const getUrlParameter = function (name) {
  const vars = [];
  const hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

  let hash;

  for (let i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');

    // --- remove anchor if exists
    if (typeof hash[1] !== 'undefined' && hash[1].indexOf('#') !== -1) {
      hash[1] = hash[1].split('#')[0];
    }

    vars.push(hash[0]);

    if (typeof hash[1] !== 'undefined') {
      vars[hash[0]] = hash[1].replace(/[\u00A0-\u9999<>\\&]/gim, function (i) {
        return '&#' + i.charCodeAt(0) + ';';
      });//encode value to handle xss injection
    }
  }
  return vars[name];
};

const removeParam = function (key, sourceURL) {
  const queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';

  let rtn = sourceURL.split('?')[0];
  let param;
  let params_arr = [];

  if (queryString !== '') {
    params_arr = queryString.split('&');

    for (let i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split('=')[0];

      if (param === key) {
        params_arr.splice(i, 1);
      }
    }

    rtn = rtn + '?' + params_arr.join('&');
  }

  return rtn;
};

export {getUrlParameter, removeParam};